import React from "react";
import Hero from "../components/Hero";
import Highlights from "../components/Highlights";
import Achievements from "../components/Achievements";
import About from "../components/About";
import PremiumProof from "../components/PremiumProof";
import BlockRenderer from "../components/blocks/BlockRenderer";
import { useCmsPage } from "../cms/useCmsContent";

export default function HomePage() {
  const { content } = useCmsPage("home");
  const blocks = content.blocks || [];

  if (blocks.length > 0) {
    return <BlockRenderer blocks={blocks} />;
  }

  const sections = content.sections || {};
  return (
    <>
      <Hero content={sections.hero} />
      <PremiumProof content={sections.proof} />
      <Highlights content={sections.highlights} />
      <Achievements content={sections.achievements} />
      <About content={sections.about} />
    </>
  );
}
